import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { AllRawData } from '../../raw-types.ts';

export const ValhallaSchema = defineSchema({
  name: 'serverValhallas',
  fields: [
    ['id', 'number'],
    ['waves', { kind: 'array', of: 'valhallaWave' }],
    // 콘텐츠 row 에 지정된 FIXED 난이도 템플릿 ID. 서버가 submit 시 재도출에 사용.
    ['fixedDifficultyTemplateId', 'string?'],
    // append-only (튜플 와이어 순서 계약). 이 valhalla row 가 속하는 시즌 테이블 FK.
    ['tableId', 'number'],
  ],
  lookupKeys: ['id'],
});

export interface RawValhallaRow {
  id: number;
  fixed_difficulty_template_id?: string | null;
  table_id: number;
}

export function valhallaFromRaw(
  row: RawValhallaRow,
  raw: Pick<AllRawData, 'valhalla_wave' | 'valhalla_wave_enemy'>
) {
  const valhallaWaves = (raw.valhalla_wave ?? [])
    .filter((w) => w.valhalla_id === row.id)
    .sort((a, b) => a.wave_number - b.wave_number);

  const lastWaveNumber =
    valhallaWaves.length > 0 ? valhallaWaves[valhallaWaves.length - 1].wave_number : -1;

  const waves = valhallaWaves.map((w) => {
    const isLastWave = w.wave_number === lastWaveNumber;
    const shopConfigId = !isLastWave && w.shop_config_id != null ? w.shop_config_id : null;

    const enemies = (raw.valhalla_wave_enemy ?? [])
      .filter((e) => e.valhalla_id === row.id && e.wave_number === w.wave_number)
      .map((e) => ({
        id: e.enemy_id,
        count: 1,
        spawnInterval: e.spawn_interval,
        spawnPattern: e.spawn_pattern ?? null,
        healthMultiplier: e.health_multiplier,
        speedMultiplier: e.speed_multiplier,
        atkMultiplier: e.atk_multiplier,
      }));

    return {
      waveNumber: w.wave_number,
      reward: w.reward,
      killGoal: w.kill_goal,
      timeLimitSeconds: w.time_limit_seconds,
      silverReward: w.silver_reward,
      shopConfigId,
      enemies,
    };
  });

  return {
    id: row.id,
    waves,
    ...(row.fixed_difficulty_template_id != null
      ? { fixedDifficultyTemplateId: row.fixed_difficulty_template_id }
      : {}),
    tableId: row.table_id,
  };
}

registerCategorySchema('serverValhallas', ValhallaSchema);
